export const ROOT_NODE = document.getElementById('root') as HTMLElement;

export const ROOT_NODE_SCROLL = {
  fix() {
    ROOT_NODE.style.overflow = 'hidden';
  },
  release() {
    ROOT_NODE.style.overflow = '';
  },
};
